import { MemberFormFieldName } from '../../../subcomponents/member-form-field/types/name';
export const UpdateMemberDetailsFormFieldName = Object.assign({}, MemberFormFieldName);
